import { render, staticRenderFns } from "./RelatedTasks.vue?vue&type=template&id=351889d4&scoped=true&"
import script from "./RelatedTasks.vue?vue&type=script&lang=js&"
export * from "./RelatedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351889d4",
  null
  
)

export default component.exports